import clsx from 'clsx';

import {statsRowT} from '@/lib/types/stats.types';

type StatsRowPropsT = {
  stats: statsRowT;
};

export const StatsRowComponent = ({stats = []}: StatsRowPropsT) => {
  const getColumnSpan = () => {
    if (!stats) return;
    switch (stats.length) {
      case 1:
        return 'xxl:col-span-12 xl:col-span-12 lg:col-span-12 md:col-span-12 sm:col-span-12 col-span-12';
      case 2:
        return 'xxl:col-span-6 xl:col-span-6 lg:col-span-6 md:col-span-6 sm:col-span-12 col-span-12';
      case 3:
        return 'xxl:col-span-4 xl:col-span-4 lg:col-span-4 md:col-span-4 sm:col-span-12 col-span-12';
      case 4:
      default:
        return 'xxl:col-span-3 xl:col-span-3 lg:col-span-3 md:col-span-3 sm:col-span-12 col-span-12';
    }
  };

  if (stats.length === 0) return null;

  return (
    <div className="grid grid-cols-12 gap-x-6">
      <div className="col-span-12 xl:col-span-12 xxl:col-span-12">
        <div className="grid grid-cols-12 gap-x-6">
          {stats.map(
            (stat, index) =>
              stat.value !== undefined &&
              stat.value !== null && (
                <div key={index} className={getColumnSpan()}>
                  <div className={clsx('box', stat.cardClass)}>
                    <div className="box-body">
                      <div className="flex items-start">
                        {stat.icon && (
                          <div className="me-4">
                            <span className={`avatar bg-${stat.color} !text-white`}>
                              <i className={stat.icon + ' text-[1.125rem]'}></i>
                            </span>
                          </div>
                        )}
                        <div className="flex-grow">
                          <span className="mb-1 block font-semibold text-[#8c9097] dark:text-white/50">
                            {stat.title}
                          </span>
                          {<h5 className="mb-1 text-[1.25rem] font-semibold">{String(stat.value)}</h5>}
                          {stat.subtitle && (
                            <p className="mb-0">
                              <span className={`badge bg-${stat.color}/10 text-${stat.color}`}>{stat.subtitle}</span>
                            </p>
                          )}
                        </div>
                        <div>
                          {stat.change && (
                            <span
                              className={`text-[0.875rem] font-semibold text-${stat.change > 0 ? 'success' : 'danger'}`}
                            >
                              {stat.change > 0 ? `+${stat.change}%` : `${stat.change}%`}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    </div>
  );
};
